import { List, ListItemButton, ListItemIcon, ListItemText, useMediaQuery, useTheme } from '@mui/material';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useMemo } from 'react';
import { NavigationItem } from '../common/state/navigation';
import useAuth from '../hooks/useAuth/useAuth';
import { globalAuthorizationAtom, userAtom } from '../state';

export interface NavigationSectionProps {
  items: NavigationItem[];
}

export default function NavigationSection({ items }: NavigationSectionProps): React.JSX.Element {
  const theme = useTheme();
  const isDownMd = useMediaQuery(theme.breakpoints.down('md'));
  const { t } = useTranslation(['common', 'catalogs']);
  const navigate = useNavigate();
  const { logout } = useAuth();
  const { isStaff } = useAtomValue(userAtom);
  const globalAuthorization = useAtomValue(globalAuthorizationAtom);

  const handleMenuItemClick = (item: NavigationItem): void => {
    if (item.to) {
      navigate(item.to);
    } else if (item.action === 'logout') {
      logout();
    } else if (item.action === 'help') {
      window.Intercom('show');
    }
  };

  const filteredItems = useMemo(() => {
    return items.filter((item) => {
      const matchScreenSize = (isDownMd && !item.desktopOnly) || (!isDownMd && !item.mobileOnly);
      const isAuthorized = !item.authorization || globalAuthorization.some(({ object, permission }) => item.authorization!.object === object && item.authorization!.permission === permission);

      return matchScreenSize && (isAuthorized || isStaff);
    });
  }, [items, globalAuthorization]);

  return (
    <List>
      {filteredItems.map((item, index) => (
        <ListItemButton key={index} onClick={() => handleMenuItemClick(item)}>
          <ListItemIcon>
            <item.icon width={24} height={24} />
          </ListItemIcon>
          <ListItemText>
            {t(item.labelKey)}
          </ListItemText>
        </ListItemButton>
      ))}
    </List>
  );
}
